export const productInfoEnum = {
  name: '品名',
  productDetails: '商品詳情',
  productSize: '商品尺寸',
  productDescription: '商品介紹',
  otherInformation: '其他資訊',
};

export const btnDescriptionEnum = {
  general: '請選擇尺寸',
  addBag: 'ADD TO BAG',
  soldOut: 'SOLD OUT',
  preShow: 'COMING SOON',
  notice: '寄送到貨通知',
};

export const btnFoodDescriptionEnum = {
  general: '請選擇規格',
  preShow: 'COMING SOON',
  addBag: 'ADD TO BAG',
  soldOut: 'SOLD OUT',
  notice: '寄送到貨通知',
};

export const btnStyleEnum = {
  disabled: 'disabled',
  activeMail: 'active-mail',
  active: 'active',
};

export const addToCartEnum = {
  addSuccess: '商品加入購物車',
};
